// extracted by mini-css-extract-plugin
export default {"fondo":"landing_fondo__G+WvD","btnEntrar":"landing_btnEntrar__Q93bK"};